import React from 'react';
import {
  Box,
  Container,
  makeStyles,
} from '@material-ui/core';
import Page from 'src/components/Page';
import View from './View';
import PageHeader from '../../components/PageHeader';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#f7f7fa',
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const LotDetailsView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Lot Details"
    >
      <Container maxWidth="lg">
        <PageHeader
          icon={<EditIcon />}
          title="Lot Details"
          subtitle="View and update lot information"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>
      </Container>
    </Page>
  );
};

export default LotDetailsView;